import React, { useEffect } from 'react';
import { languageService } from '../js/languageService';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
    const currentLanguage = languageService.getCurrentLanguage();

    const handleLanguageChange = () => {
        const newLanguage = currentLanguage === 'en' ? 'es' : 'en';
        languageService.setLanguage(newLanguage);
        // Forzar actualización del DOM
        document.dispatchEvent(new CustomEvent('languageChanged', { detail: newLanguage }));
    };

    useEffect(() => {
        const handleLanguageChange = () => {
            languageService.updatePageContent();
        };

        document.addEventListener('languageChanged', handleLanguageChange);
        return () => {
            document.removeEventListener('languageChanged', handleLanguageChange);
        };
    }, []);

    return (
        <button
            onClick={handleLanguageChange}
            className="glass-card w-10 h-10 flex items-center justify-center rounded-full hover:bg-primary/10 transition-colors"
            title={currentLanguage === 'en' ? 'Switch to Spanish' : 'Cambiar a Inglés'}
        >
            <Globe size={18} className="text-primary" />
            <span className="sr-only">{currentLanguage === 'en' ? 'EN' : 'ES'}</span>
        </button>
    );
};

export default LanguageSwitcher; 